module.exports = __webpack_public_path__ + "fonts/Gilroy-Medium.ce12e7f2.eot";